import { render, staticRenderFns } from "./number-range-input.vue?vue&type=template&id=a04fabbe&"
import script from "./number-range-input.vue?vue&type=script&lang=js&"
export * from "./number-range-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports